import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mockArticles } from '@/mocks/articles';

interface Props {
  article: typeof mockArticles[0] | undefined;
}

export default function ArticleContent({ article }: Props) {
  const { t } = useTranslation();

  if (!article) return null;

  const titleBase = article.title.split('？')[0].replace(/^某/, '');

  const contentParagraphs = [
    `据本平台独家获悉，${titleBase}事件近日引发全网热议。多位知情人士向51吃瓜每日大赛提供了独家内幕信息，让我们一探究竟。`,
    `一位不愿透露姓名的业内人士向本平台爆料称，事情远比外界看到的要复杂得多。"这背后涉及的利益纠葛非常复杂，不是表面上那么简单。"该人士表示，目前相关各方都在密切关注事态发展。`,
    `在事件发酵的过程中，社交媒体上的讨论热度持续攀升。截至目前，相关话题在微博上的阅读量已突破5亿，讨论量超过50万条。不少网友纷纷表达了自己的看法，有支持也有质疑。`,
    `本平台记者联系了当事方的经纪公司，对方以"不方便回应"为由婉拒了采访请求。但据圈内人士分析，如果爆料内容属实，可能会对当事人的商业代言和后续工作安排产生重大影响。`,
    `与此同时，多个与该艺人相关的品牌合作方也已被媒体求证。据某品牌公关负责人表示："我们正在密切关注事态发展，会根据具体情况做出相应决策。"业内专家分析称，若事件持续发酵，当事人的商业价值可能面临大幅缩水。`,
    `值得注意的是，该事件并非近期娱乐圈中的孤例。今年以来，已有多位艺人因类似问题陷入舆论漩涡，这也引发了公众对娱乐圈行业规范的广泛讨论。不少网友呼吁建立更加严格的艺人行为准则和行业监督机制。`,
    `法律界人士对此事件也发表了看法。某知名律师表示，如果爆料内容涉及违法违规行为，当事人可能面临法律追责。但在此之前，公众应保持理性，等待权威部门的调查结果。`,
    `51吃瓜每日大赛将持续关注此事的最新进展，为各位瓜友带来第一手的独家爆料。同时，我们也呼吁大家在吃瓜过程中保持理性，不信谣、不传谣，共同维护清朗的网络空间。`,
  ];

  return (
    <article className="w-full px-4 md:px-8 py-14 md:py-18 bg-background-50">
      <div className="max-w-[720px] mx-auto">
        <div className="flex justify-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-700 text-xs font-medium whitespace-nowrap">
            {t('article_label')}
          </span>
        </div>

        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 text-center leading-tight mb-10">
          {article.title.split('？')[0]}
          <br />
          独家深度解析
        </h2>

        <div className="space-y-6">
          {contentParagraphs.map((para, idx) => (
            <p
              key={idx}
              className={`text-sm md:text-base leading-relaxed ${
                idx % 2 === 0 ? 'text-foreground-900' : 'text-foreground-700'
              }`}
            >
              {para}
            </p>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-500 whitespace-nowrap">标签：</span>
            <Link
              to={`/category/${article.category}`}
              className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              {article.categoryName}
            </Link>
            <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
              独家爆料
            </span>
            <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
              吃瓜前线
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}